<template>
  <section>
    <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide">
      <h2>Certificaciones</h2>
    </div>
    <div class="bg-white p-4 md:p-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      <TaskWrapperCertifications 
        v-for="(item, index) in certifications"
        @remove="removeCertification(index)"
        :key="`certs_${index}`"
        :value="item"
      />
      <div class="space-y-4">
        <Select
          id="idCertificate"
          :data="allCertifications"
          track-by="certificateName"
          track-by2="certificateEndDate"
          separator=" / "
          v-model.number="selectedCertification"
          placeholder="Elija una certificación"
        />
        <ButtonAction @action="addCertification" large>
          {{ $t("lang.msg.addCertification") }}
        </ButtonAction>
      </div>
    </div>
  </section>
</template>

<script>
import CalendarMixin from "@/components/mixins/CalendarMixin";
export default {
  name: "Certifications",
  mixins: [CalendarMixin],
  props: {
    idSample: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      certifications: [],
      allCertifications: [],
      selectedCertification: null
    }
  },
  created() {
    this.fetchAllCertifications();
    this.fetchSampleCertifications();
  },
  methods: {
    fetchAllCertifications() {
      this.$axios.get(`api/Certificats/GetCertificatActive`).then(response => {
        let data = response.data;

        data.forEach(element => {
          this.formatDateToStringWithoutTime(element, ["certificateEndDate"]);
        });

        this.allCertifications = response.data;
      });
    },
    // Mostrar las certificaciones de una muestra.
    fetchSampleCertifications() {
      this.$axios.post(`api/Certificats/GetThisCer`, {
        idSample: this.idSample
      }).then(response => {
        this.certifications = response.data;
      });
    },
    addCertification() {
      if (this.selectedCertification != null) {
        // Añadimos una certificación a una muestra.
        this.$axios.post(`api/Certificats/AddCertificatSample`, {
          idCertificat: this.selectedCertification,
          idSample: this.idSample
        }).then(() => {
          this.fetchSampleCertifications();
          this.selectedCertification = null;
          this.openAlert('success', 'Certificación añadida', null);
        });
      }
    },
    removeCertification(index) {
      this.$axios.post(`api/Certificats/DeleteCertificatSample`, {
        idCertificatSample: this.certifications[index].idCertificatSample
      }).then(() => {
        this.certifications.splice(index, 1);
        this.openAlert('success', 'Certificación eliminada', null);
      });
    }
  }
};
</script>
